export default __webpack_public_path__ + "static/media/qantas-explorer.13573a97.svg";